class OpeningPopup {
    constructor(target, options = {}) { 
        this.target = document.querySelector(target); 
        this.width = options.width || '800px'; 
        this.height = options.height || '600px'; 
        this.backgroundColor = options.backgroundColor || 'white';
        this.dropshadow = options.dropshadow || false; 
        this.closeButton = options.closeButton || false;
        this.className = options.className || 'popup'; 
        this.makePopup(); 
    }

    makePopup() {
        const popup = document.createElement('div');
        popup.className = this.className;
        popup.id = 'popup';	
        popup.innerText = 'Popup';

        popup.style.backgroundColor = this.backgroundColor;
        popup.style.width = this.width;
        popup.style.height = this.height;

        if (this.dropshadow) {
            popup.style.boxShadow = "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)";
        }

        if (this.closeButton) {
            createCloseButton(popup);
        }

        this.target.appendChild(popup); 
    }

}

